export class StatusProduto {
    id: string;
    nome: string;
}


export enum StatusProdutoEnum {
    Ativo = '1',
    EmDesenvolvimento = '2',
    Indisponivel = '3'
}